import {useSuspenseQuery} from '@tanstack/react-query';

import {api} from '@/lib/ky';

import {layerTemplateSchema} from '../utils/schemas/layer';

import {layerTemplateKeys} from './queryKeys';

import type {
  ExtractFnReturnType,
  QueryConfig,
  QueryConfig2,
} from '@/lib/react-query';

export const getLayerTemplate = async (id: string) => {
  const data = await api.get(`layers/${id}`).json();
  return layerTemplateSchema.parse(data);
};

export const useLayerTemplate = (
  id: string,
  config?: QueryConfig<QueryFnType>
) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: layerTemplateKeys.detail(id),
    queryFn: () => getLayerTemplate(id),
  });
};
export const useLayerTemplateLoader = (config: QueryConfig2<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getLayerTemplate;
